import React, { useEffect, useRef, useState } from "react";
import DrawDeck, { CANVAS_SIZE } from "./DrawDeck";
import { RadioGroup } from "@mui/material";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import DeckRadio from "./DeckRadio";
import { fixedState } from "./DecksState";

function DeckAttachment({ deckState, updateDeckState }) {
    const canvasRef = useRef(null);
    const textFields = useRef({});
    const [accepted, setAccepted] = useState(false);
    const [accepted2, setAccepted2] = useState(false);
    const [dialogOpen, setDialogOpen] = useState(false); // State to track if the dialog is open
    const [dialog2Open, setDialog2Open] = useState(false); // State to track if the second dialog is open

    const { deckShape, deckRotation, deckHeight, deckAttachment } = deckState.deckStructure;

    const handleCanvasClick = (event) => {
        // Add your click handling logic here
    };

    const handleRadioChange = (e) => {
        let deckFreestanding = deckState.deckStructure.deckFreestanding;
        if (e.target.value.toLowerCase().includes("timber")) {
            deckFreestanding = false;
            setAccepted(false);
            setAccepted2(false);
        }

        updateDeckState({
            ...deckState,
            deckStructure: {
                ...deckState.deckStructure,
                deckAttachment: e.target.value,
                deckFreestanding,
            },
        });
    };

    useEffect(() => {
        // Update the dialog open state based on deckHeight and deckAttachment
        const shouldDialogOpen = !accepted && deckAttachment === "Masonry";
        const shouldDialog2Open = accepted && !accepted2 && deckAttachment === "Masonry";

        setDialogOpen(shouldDialogOpen);
        setDialog2Open(shouldDialog2Open);
    }, [deckHeight, accepted, accepted2, deckAttachment]);

    return (
        <div style={{ padding: 15, display: "flex", gap: "20px" }}>
            <DrawDeck
                canvasRef={canvasRef}
                textFields={textFields}
                deckShape={deckShape}
                deckRotation={deckRotation}
                deckState={deckState}
                updateDeckState={updateDeckState}
                hideText={false}
                hideGrid={true}
                clickAttachments={!deckState.deckStructure.deckFreestanding}
                key={dialogOpen + dialog2Open} // Force rerender by changing key
            />
            <div>
                <h3 style={{ padding: "20px 0px", margin: 0 }}>Select the sides that are attached to your decking</h3>
                {deckState.deckStructure.deckFreestanding ? (
                    <p>⚠️ Freestanding Structures can not have attachments</p>
                ) : (
                    <p>You can simply click 👆 on the edge of your deck to add attachments!</p>
                )}
                <DeckRadio
                    style={{ flexDirection: "column" }}
                    onChange={handleRadioChange}
                    value={deckState.deckStructure.deckAttachment}
                    fixedMap={fixedState.deckStructure.deckAttachment}
                />
            </div>
            <Dialog disableEnforceFocus open={dialogOpen} onClose={() => setAccepted(false)}>
                <DialogTitle>Warning</DialogTitle>
                <DialogContent>
                    As Per Reg12.3.2 of the ABCB Housing Provisions 2022, a masonry wall that is supporting a deck must
                    be core filled with reinforced concrete.
                    <br />
                    Does your proposed design satisfy this requirement?
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setAccepted(true)}>Yes</Button>
                    <Button
                        onClick={() => {
                            setAccepted(true);
                            updateDeckState({
                                ...deckState,
                                deckStructure: {
                                    ...deckState.deckStructure,
                                    deckFreestanding: true,
                                },
                                deckAttachments: { rect1: {}, rect2: {} },
                            });
                        }}
                    >
                        No (Freestanding Only)
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog disableEnforceFocus open={dialog2Open} onClose={() => setAccepted2(false)}>
                <DialogTitle>Masonry Warning</DialogTitle>
                <DialogContent>
                    Per NCC2022 Vol 2 H1D11 (j), the masonry wall 'must be continuous from the uppermost surface of the
                    deck to the supporting footing and contain no openings or lintels below the deck.
                    <br />
                    Does your proposed design satisfy this requirement?
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => {
                            setAccepted2(true);
                            updateDeckState({
                                ...deckState,
                                deckStructure: {
                                    ...deckState.deckStructure,
                                    deckFreestanding: false,
                                    deckAttachment: "Masonry",
                                },
                            });
                        }}
                    >
                        Yes
                    </Button>
                    <Button
                        onClick={() => {
                            setAccepted2(true);
                            updateDeckState({
                                ...deckState,
                                deckStructure: {
                                    ...deckState.deckStructure,
                                    deckFreestanding: true,
                                },
                                deckAttachments: { rect1: {}, rect2: {} },
                            });
                        }}
                    >
                        No (Freestanding Only)
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default DeckAttachment;
